module.exports = __webpack_public_path__ + "static/media/foto1.dcdf0172.jpg";